"use client";

// src/components/Icons/Windows.svg
var Windows_default = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2248%22%20height%3D%2248%22%20fill%3D%22none%22%3E%3Cg%20clip-path%3D%22url(%23a)%22%3E%3Cpath%20fill%3D%22%230078D4%22%20d%3D%22M0%200h22.755v22.745H0V0Zm25.245%200H48v22.745H25.245V0ZM0%2025.245h22.755V48H0V25.245Zm25.245%200H48V48H25.245%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22M0%200h48v48H0z%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
export {
  Windows_default as default
};
